/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, February 2021
 */

import React from 'react';
import EserviceError from './EserviceError';
import ServicesLayout from '../../components/ServicesLayout';

const title = 'Błąd po stronie serwera';


export default {

  path: '/eserviceError/',

  action() {
    return {
      title,
      component: <ServicesLayout absoluteFooter>
        <EserviceError />
      </ServicesLayout>,
    };
  },
};



// WEBPACK FOOTER //
// src/routes/eserviceError/index.js